"use strict";

/*
 Methods for the objects which wrap around a value and hold other metadata
 */
var create = function (v) {
    return {
        value: v
    };
};

var getValue = function (w) {
    return w.value;
};

var setValue = function (w, v) {
    w.value = v;
};

var linkPersonKey = function (w, k) {
    w.personKey = k;
};

var unlinkPersonKey = function (w) {
    delete w.personKey;
};

var getPersonKey = function (w) {
    return w.personKey;
};


var resolveValuePath = function (w, path) {
    var value = getValue(w);
    return path.reduce(function (acc, curr) {
        if (!acc) {
            return acc;
        }

        return acc[curr];
    }, value);
};

var hasValuePath = function (w, path) {
    var parentPath = path.slice();
    var pathKey = parentPath.pop();

    var parent = resolveValuePath(w, parentPath);
    if (!parent) {
        return false;
    }

    return (pathKey in parent);
};


var _path = function (..._args) {
    var pathArr = Array.prototype.slice.apply(arguments);
    return function (..._args2) {
        var args = arguments;
        return pathArr.map(function (arrEntry) {
            if (arrEntry instanceof String || typeof arrEntry === "string") {
                return arrEntry;
            }
            else if (typeof arrEntry === "number") {
                return args[arrEntry];
            }
            else if (typeof arrEntry === "function") {
                return arrEntry.apply(null, args);
            }
        });
    };
};


export default {
    create: create,
    getValue: getValue,
    setValue: setValue,
    linkPersonKey: linkPersonKey,
    unlinkPersonKey: unlinkPersonKey,
    getPersonKey: getPersonKey,

    resolveValuePath: resolveValuePath,
    hasValuePath: hasValuePath,


    /**
     *
     * invitee specific properties
     */
    invitees: {
        getTimestampPath: _path(function (path) {return path[0] + "-timestamp";}),
        getTagsPath: _path("tags"),
        getTagPath: _path("tags", 0),
        getDetailPath: _path(0),
        getWasEvictedPath: _path("wasEvicted"),
        getHasLeftPath: _path("hasLeft"),
        getNamePath: _path("name"),
        getEmailPath: _path("email"),
        getAvatarPath: _path("avatar"),
        getBadEmailPath: _path("badEmail"),
        getStatusPath: _path("status"),
        getCreatedAtPath: _path("createdAt"),
        getCreatedByPath: _path("createdBy"),
        getNameTimestampPath: _path("name-timestamp")
    },

    /**
     *
     * user profile specific properties
     */
    userProfiles: {
        getTimestampPath: _path("profile", function (path) { return path[1] + "-timestamp";}),
        getTagsPath: _path("profile", "tags"),
        getTagPath: _path("profile", "tags", 0),
        getDetailPath: _path("profile", 0),
        getWasEvictedPath: _path("wasEvicted"),
        getHasLeftPath: _path("hasLeft"),
        getNamePath: _path("profile", "name"),
        getEmailPath: _path("profile", "email"),
        getAvatarPath: _path("profile", "avatar"),
        getDisplayNamePath: _path("profile", "displayName"),
        getBadEmailPath: _path("profile", "badEmail"),
        getStatusPath: _path("profile", "status"),
        getCreatedAtPath: _path("profile", "createdAt"),
        getCreatedByPath: _path("profile", "createdBy"),
        getNameTimestampPath: _path("name-timestamp")
    },

    /**
     *
     * global profile specific properties
     */
    globalProfiles: {
        getEmailPath: _path("email"),
        getEmailVerifiedPath: _path("email_verified")
    }

};
